import { selectCurrentUser } from '@user/store/authorization'
import { useAppSelector } from '@user/store/hooks'
import { pestPacOrderUrl } from '../constants'

export function useGetOrderUrl(appointmentId: string) {
  const { clientUrl } = useAppSelector(selectCurrentUser)
  return `${clientUrl}/${pestPacOrderUrl}${appointmentId}`
}
